/* eslint-disable react/jsx-no-useless-fragment */
import React, { ReactNode, useEffect } from 'react'

import { SITE_TITLE } from '../../constants'

interface SiteContainerProps {
  children: ReactNode
  title?: string
}

/**
 *
 * Site container wraps around the ScreenContainer component.
 * inside the useEffect hook, we update the document title for the current screen
 *
 */
export const SiteContainer = (props: SiteContainerProps) => {
  const { children, title } = props

  useEffect(() => {
    document.title = title ? `${title} | ${SITE_TITLE}` : SITE_TITLE
  }, [title])

  return <>{children}</>
}

export default SiteContainer
